import { RouteObject } from 'react-router';
import { Dashboard } from './content/Mesh';
import Login from './content/Mesh/MeshLogin';

const routes: RouteObject[] = [
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '*',
    element: <Dashboard />
  }
];

export default routes;
